// ResetPassword.js
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import '../../styles.css';

import { resetPassword } from '../../redux/slices/customerAuthSlice'; // Replace with your password reset action
import bgSignin from '../../images/bg-signin.jpg';
import logo from '../../images/logo-agc.png';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.customer_auth);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }

    if (status !== 'loading') {
      const response = await dispatch(resetPassword(newPassword));

      if (response.payload && response.payload.status === 'Success') {
        setSuccessMessage('Password reset successful!');
        setErrorMessage(null);
        navigate('/login'); // Redirect to login page
      } else if (response.payload && response.payload.status === 'Error') {
        setErrorMessage(response.payload.message);
        setSuccessMessage(null);
      } else {
        setErrorMessage('Unexpected error occurred. Please try again.');
        setSuccessMessage(null);
      }
    }
  };

  return (
    <div className="dashboard-container" id="app-body">
      <div className="bg-signin page-signin" style={{ backgroundImage: `url(${bgSignin})` }}>
        <div className="main-body justify-between">
          <div className="form-body">
            <div className="form-body-container">
              <section id="form" className="form">
                <form onSubmit={handleSubmit}>
                  <div className="logo-signin">
                    <img src={logo} alt="logo" />
                  </div>
                  
                  <div className="form-sigin-wrap">
                    <h3>Reset Password</h3>
                    <p>Enter a new password for your account.</p>

                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

                    <div className="form-group flex flex-col align-start">
                      <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group flex flex-col align-start">
                      <input
                        type="password"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <button type="submit" className="btn">Reset Password</button>
                    </div>

                    <div className="form-group flex justify-end">
                      <Link className="back-to-login" to="/login">Back to Login</Link>
                    </div>

                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
        <div className="text-center">
          <p className="text-muted">© 2024 AlexGambleCoaching. Crafted with <i className="mdi mdi-heart text-primary"></i></p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;